<template>

    <div class="px-4 sm:px-6 lg:px-8 bg-gray-800 pt-10">
      <form class="space-y-8 divide-y divide-gray-700">
        <div class="space-y-8 divide-y divide-gray-700">
  
  
          <div>
  
            <div v-if="placeDetailsFullData" class="flex flex-wrap -mx-3">
              <div class="mt-6 sm:mt-0 w-full sm:w-10/12 px-3">
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="placeDetailsFullData.name"
                    name="position"
                    id="position"
                    autocomplete="position"
                    class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 text-3xl font-semibold text-white bg-gray-800"
                  />
                </div>
              </div>
            </div>
  
  
  
            <div class="mt-1 flex rounded-md shadow-sm"></div>
  
            <div v-if="placeDetailsFullData" class="flex flex-wrap -mx-3 mt-4">
              <div class="mt-6 sm:mt-0 w-full sm:w-2/5 px-3">
                <label
                  for="street"
                  class="block text-sm font-medium text-gray-200"
                  >street</label
                >
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="placeDetailsFullData.fullAdress.street"
                    name="street"
                    id="street"
                    autocomplete="street"
                    class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                  />
                </div>
              </div>
              <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-3">
                <label
                  for="postcode"
                  class="block text-sm font-medium text-gray-200"
                  >postcode</label
                >
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="placeDetailsFullData.fullAdress.postcode"
                    name="postcode"
                    id="postcode"
                    autocomplete="postcode"
                    class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                  />
                </div>
              </div>
              <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-3">
                <label for="city" class="block text-sm font-medium text-gray-200"
                  >city</label
                >
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="placeDetailsFullData.fullAdress.city"
                    name="city"
                    id="city"
                    autocomplete="city"
                    class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                  />
                </div>
              </div>
  
            </div>
  



            <div v-if="placeDetailsFullData" class="mt-6 flex">


                <div class="mt-1">
                  <p
                    class="px-3 py-3 rounded-md border-yellow-600 font-bold sm:text-sm text-black bg-yellow-600"
                  >★ {{ placeDetailsFullData.rating }}</p>  
                </div>
  
                <div class="mt-1">
                  <p
                    class="px-3 py-3 rounded-md border-yellow-600 font-bold sm:text-sm text-yellow-600"
                  >{{ placeDetailsFullData.user_ratings_total }}</p>  
                </div>
  
  
                <div class="mt-1">
                  <p
                    class="px-3 py-3 rounded-md border-yellow-600 font-bold sm:text-sm text-yellow-600"
                  >{{ priceLevel }}</p>  
                </div>
  
            
            </div>
  

  
            
  
              <div class="mt-4" v-if="placeDetailsFullData">
                <div class="flex flex-wrap">
                  <div v-for="photo in placeDetailsFull.photos" :key="photo" class="w-48 h-48 overflow-hidden m-3 relative">
                    <img :src="photo.getUrl({ maxWidth: 1000, maxHeight: 1000 })" class="min-w-full rounded-md min-h-full object-cover object-center" />
                    <div class="absolute bottom-0 right-0 bg-black bg-opacity-50 text-white text-xs p-0 px-1">
                      <div v-html="photo.html_attributions.join(', ')" class="whitespace-nowrap"></div>
                    </div>
                  </div>
                </div>
              </div>




  <div class="space-y-4 mt-5 mb-10" v-if="placeDetailsFullData">
    <div v-for="review in placeDetailsFullData.reviews" :key="review.time" class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700">
     
     
        <div class="md:flex">
        <div class="p-8">
          <div class="mt-4">
            <span class="text-yellow-400 font-medium">★ {{ review.rating }}</span>
            <span class="text-sm ml-2 text-white">{{ review.relative_time_description }}</span>
            <span class="text-sm ml-2 text-gray-500">{{ timestampToDate(review.time) }}</span>

            
          </div>

          <a :href="review.author_url" class="block mt-1 text-lg leading-tight font-medium text-white hover:underline">{{ review.author_name }}</a>
          <p class="mt-2 text-white">{{ review.text }}</p>
          <span class="uppercase mt-5 tracking-wide text-sm text-indigo-500 font-semibold">{{ review.language }}</span>

        </div>
      </div>
    </div>
  </div>






          </div>
        </div>
  
  




        <!-- <div class="mt-4 sm:flex-none">
            <p class="text-white">TEMP DATA</p>
            <p class="text-white">Chińczyk na Estrady Warszawa</p>
            <div v-if="placeDetailsFull">
                <p>placeDetailsFull</p>
                <pre>{{ placeDetailsFull }}</pre>
            </div>
        </div> -->

      </form>
  
  
  
  
  
      <div class="fixed bottom-0 left-0 w-full p-5 bg-gray-800">
        <div class="flex justify-end items-center">

          <div class="flex justify-end">
            <button
              @click="goBack"
              type="button"
              class="rounded-md border border-gray-600 bg-gray-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-offset-2"
            >
              Cancel
            </button>
            <button
              type="submit"
              @click.prevent="saveAll"
              class="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              Save
            </button>
          </div>
        </div>
      </div>
  
  
  
    </div>
  </template>




<script setup>
import { ref, compute, watch, computed } from 'vue';



const props = defineProps({
    placeDetailsFull: Object,
});


// const placeDetailsFullData = ref(null);


// npaiszmi mi boilerplate na computed
const placeDetailsFullData = computed(() => {
    console.log("props.placeDetailsFull in computerd: ", props.placeDetailsFull);
    // if (newValue && newValue.geometry && newValue.geometry.viewport) {
    // if (props.placeDetailsFull !== null && props.placeDetailsFull !== undefined && props.placeDetailsFull.geometry && props.placeDetailsFull.geometry.viewport) {
    //     const newValue = props.placeDetailsFull;

    if (props.placeDetailsFull) {

    // Upewnij się, że address_components istnieje przed próbą dostępu do jego elementów
    if (props.placeDetailsFull.address_components) {
      const stNumber = props.placeDetailsFull.address_components[0]?.short_name ?? 'N/A';
      const street = props.placeDetailsFull.address_components[1]?.short_name ?? 'N/A';
      const postcode = props.placeDetailsFull.address_components[7]?.short_name ?? 'N/A';
      const city = props.placeDetailsFull.address_components[4]?.short_name ?? 'N/A';
      const countryCode = props.placeDetailsFull.address_components[6]?.short_name ?? 'N/A';
      const positionLat = props.placeDetailsFull.geometry.location?.lat ?? 'N/A';
      const positionLng = props.placeDetailsFull.geometry.location?.lng ?? 'N/A';
      const price_level = props.placeDetailsFull.price_level ?? 'N/A';
      const formatted_address = props.placeDetailsFull.formatted_address ?? 'N/A';

      const  rating = props.placeDetailsFull.rating ?? 'N/A';
      const  formatted_phone_number = props.placeDetailsFull.formatted_phone_number ?? 'N/A';
      const  international_phone_number = props.placeDetailsFull.international_phone_number ?? 'N/A';
      const  adr_address = props.placeDetailsFull.adr_address ?? 'N/A';
      const  business_status = props.placeDetailsFull.business_status ?? 'N/A';
      const  icon = props.placeDetailsFull.icon ?? 'N/A';
      const  name = props.placeDetailsFull.name ?? 'N/A';
      const  photos = props.placeDetailsFull.photos ?? 'N/A';
      const  place_id = props.placeDetailsFull.place_id ?? 'N/A';
      const reviews = props.placeDetailsFull.reviews ?? 'N/A';
      const types = props.placeDetailsFull.types ?? 'N/A';
      const url = props.placeDetailsFull.url ?? 'N/A';
      const vicinity = props.placeDetailsFull.vicinity ?? 'N/A';
      const website = props.placeDetailsFull.website ?? 'N/A';
      const html_attributions = props.placeDetailsFull.html_attributions ?? 'N/A';
      const opening_hours = props.placeDetailsFull.opening_hours ?? 'N/A';
      const user_ratings_total = props.placeDetailsFull.user_ratings_total ?? 'N/A';



      const dataPrepared = {
        formatted_address,
        adr_address,

        fullAdress: {
          street: `${street} ${stNumber}`,
          city,
          postcode,
          countryCode,
        },

        position: `${positionLat}, ${positionLng}`,
        price_level,
        rating,
        formatted_phone_number,
        international_phone_number,
        business_status,
        icon,
        name,
        opening_hours,
        photos,
        place_id,
        reviews,
        types,
        url,
        vicinity,
        website,
        html_attributions,
        user_ratings_total,

      };

      console.log("dataPrepared2: ", dataPrepared);
      return dataPrepared
    }
    }
    }
);





const priceLevel = computed(() => {
  // Sprawdź, czy placeDetailsFullData i placeDetailsFullData.price_level istnieją
  if (placeDetailsFullData.value && placeDetailsFullData.value.price_level != null) {
    // Zwróć ciąg znaków '$' powielony odpowiednią liczbę razy
    return '$'.repeat(placeDetailsFullData.value.price_level);
  }
  return ''; // Zwróć pusty ciąg, jeśli price_level nie jest dostępny
});



watch(() => props.placeDetailsFull, (newVal) => {
  console.log("Nowa wartość placeDetailsFull w placeDetailsComponent:", newVal);
});


function timestampToDate(timestamp) {
    // Tworzenie nowego obiektu Date, pomnóż timestamp przez 1000, aby przekonwertować sekundy na milisekundy
    const date = new Date(timestamp * 1000);
    
    // Formatowanie daty do postaci czytelnej
    // możesz dostosować format daty zgodnie z własnymi potrzebami
    const formattedDate = date.toLocaleDateString("pl-PL", {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
    
    return formattedDate;
}





</script>